// Taurine PDP behaviours (OptimaPaw): sections fade up on scroll, stats count up from 0.
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sections = [...document.querySelectorAll('main .shopify-section')].slice(1); // not the buy box
  const countUp = el => {
    const target = +el.dataset.count, start = performance.now(), dur = 2000;
    const step = now => { const t = Math.min(1, (now - start) / dur); el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3))) + '%'; if (t < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  };
  if (reduce || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-visible');
    e.target.querySelectorAll('[data-count]').forEach(countUp);
    io.unobserve(e.target);
  }), { threshold: 0.15 });
  sections.forEach(s => {
    if (s.getBoundingClientRect().top < innerHeight) return; // already on screen: leave as is
    s.classList.add('tp-reveal');
    s.querySelectorAll('[data-count]').forEach(el => (el.textContent = '0%'));
    io.observe(s);
  });
})();